import templateUrl from "emun.order/order-totals-prompt.htm";
import OrderTotalsPromptController from "emun.order/order-totals-prompt.controller";
import open from "webmodals/open";

let OrderTotalsPrompt = options => {
  let modalInstance = open({
    size: options.size || "md",
    templateUrl: options.templateUrl || templateUrl,
    controller: OrderTotalsPromptController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default OrderTotalsPrompt;
